export const APP_VERSION = '2.6.0';

export const C = {
  brun:'#3D1F0E', brun2:'#5C3020', rose:'#C49A8A', pale:'#E8D5CC',
  lilas:'#A89BB5', or:'#C4A882', creme:'#F7F2EE', blanc:'#FDFAF7',
  texte:'#2E1F17', gris:'#8A7A74', vert:'#7FAF8A'
};